import { useEffect, useState } from "react";
import "moment/locale/he";
import { DatePicker } from "@mui/x-date-pickers";
import CustomDialog from "./CustomDialog";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import moment from "moment";
import CustomButton from "./CustomButton";
import { Divider, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { PMT_TYPE, ST_TYPE } from "../containers/reports/const";
import NullCheck from "./NullCheck";

const CustomSearch = ({
  open,
  setOpen,
  callBack,
  btnTitle,
  resetSearchBtn,
  title,
  defaultDates,
  showEmp,
  showClient,
  showStatus,
  showPmtSt,
  mcList,
  showInvoiceSt,
}) => {
  const { bt } = useBizTypeTranslation();
  const employeeslist = useSelector((state) => state?.employees?.list);
  const clientsList = useSelector((state) => state?.clients?.list);
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [selectedEmployee, setSelectedEmployee] = useState("all");
  const [selectedClients, setSelectedClients] = useState("all");
  const [selectedPmtType, setSelectedPmtType] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState("all");
  const [selectedBtnDate, setSelectedBtnDate] = useState(1);
  const [selectedMc, setSelectedMc] = useState(null);

  const BTN_DATES = [
    { id: 1, title: "TODAY" },
    { id: 2, title: "THIS_WEEK" },
    { id: 3, title: "THIS_MONTH" },
    { id: 4, title: "THIS_YEAR" },
  ]

  useEffect(() => {
    defaultDatesFunc(defaultDates)
  }, [defaultDates])

  const onSelectedBtnDate = (id) => {
    setSelectedBtnDate(id)
    if (id === 1) {
      setStartDate(moment());
      setEndDate(moment());
    }
    else if (id === 2) {
      setStartDate(moment().startOf("week"));
      setEndDate(moment());
    }
    else if (id === 3) {
      setStartDate(moment().startOf("month"));
      setEndDate(moment());
    }
    else if (id === 4) {
      setStartDate(moment().startOf("year"));
      setEndDate(moment());
    }
  }

  const defaultDatesFunc = (defaultDates) => {
    if (defaultDates === 'today') {
      setStartDate(moment());
      setEndDate(moment());
    }

    else if (defaultDates === 'thisWeek') {
      setStartDate(moment().startOf("week"));
      setEndDate(moment());
    }

    else if (defaultDates === 'thisMonth') {
      setStartDate(moment().startOf("month"));
      setEndDate(moment());
    }

    else if (defaultDates === 'thisYear') {
      setStartDate(moment().startOf("year"));
      setEndDate(moment());
    }
    else {
      setStartDate(moment());
      setEndDate(moment());
    }
  }

  const callBackSearch = () => {
    callBack({
      startDate: moment(startDate).startOf("day"),
      endDate: moment(endDate).endOf("day"),
      selectedEmployee,
      selectedClients,
      selectedPmtType,
      selectedStatus,
      selectedInvoiceStatus,
      selectedMc,
    });
    setOpen(false);
  };

  const resetSearch = () => {
    defaultDatesFunc(defaultDates)
    setSelectedEmployee("all");
    setSelectedClients("all");
    setSelectedPmtType("all");
    setSelectedStatus("all");
    setSelectedInvoiceStatus("all");
    callBack({ reset: true })
    setOpen(false);
  }

  return (
    <CustomDialog
      title={title ?? "SEARCH"}
      onClose={() => setOpen(false)}
      open={open}
      actionBtn={{ title: btnTitle ?? "SEARCH", onClick: () => callBackSearch() }}
      extraBtn1={resetSearchBtn ? { title: btnTitle ?? "RESET", color: 'error', onClick: () => resetSearch() } : null}
    >
      <Stack spacing={2}>
        <Stack direction={{ xs: "column", md: "row" }} justifyContent="center" spacing={2}>
          {BTN_DATES?.map(btn => {
            return (
              <CustomButton
                key={btn?.id}
                width={{ xs: "100%", md: 100 }}
                title={btn?.title}
                variant={selectedBtnDate === btn?.id ? "contained" : "outlined"}
                onClick={() => onSelectedBtnDate(btn?.id)}
              />
            )
          })}
        </Stack>

        <Stack direction="row" spacing={2}>
          <DatePicker
            sx={{ width: "100%" }}
            label={bt("START_DATE")}
            maxDate={moment()}
            minDate={moment()?.add(-1, "years")}
            value={startDate}
            onChange={(e) => setStartDate(e)}
          />

          <DatePicker
            sx={{ width: "100%" }}
            label={bt("END_DATE")}
            maxDate={moment()}
            value={endDate}
            onChange={(e) => setEndDate(e)}
          />
        </Stack>

        <Divider />

        <Stack width="100%" direction={{ xs: "column", md: "row" }} spacing={1}>
          {/* select employee */}
          <NullCheck valueForCheck={showEmp}>
            <FormControl fullWidth>
              <InputLabel >{bt("EMPLOYEE")}</InputLabel>
              <Select
                sx={{ width: { xs: "100%", md: 250 } }}
                size="small"
                label={bt("EMPLOYEE")}
                value={selectedEmployee}
                onChange={(e) => setSelectedEmployee(e.target.value)}
                MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
              >
                <MenuItem value={"all"}>
                  <Typography>{bt("ALL_EMPLOYEES")}</Typography>
                </MenuItem>
                {employeeslist?.map((emp, index) => {
                  return (
                    <MenuItem key={index} value={emp?.id}>
                      <Typography>{`${emp.fn} ${emp.ln}`}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </NullCheck>

          {/* select client */}
          <NullCheck valueForCheck={showClient}>
            <FormControl fullWidth>
              <InputLabel >{bt("CLIENTS")}</InputLabel>
              <Select
                sx={{ width: { xs: "100%", md: 250 } }}
                size="small"
                label={bt("CLIENTS")}
                value={selectedClients}
                onChange={(e) => setSelectedClients(e.target.value)}
                MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}

              >
                <MenuItem value={"all"}>
                  <Typography>{bt("ALL_CLIENTS")}</Typography>
                </MenuItem>
                {clientsList?.map((client, index) => {
                  return (
                    <MenuItem key={index} value={client?.guid}>
                      <Typography>
                        {client.company ? client.company : client.contactName}
                      </Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </NullCheck>
        </Stack>

        <Stack width="100%" direction={{ xs: "column", md: "row" }} spacing={1}>
          {/* select status */}
          <NullCheck valueForCheck={showStatus}>
            <FormControl fullWidth>
              <InputLabel >{bt("STATUS")}</InputLabel>
              <Select
                sx={{ width: { xs: "100%", md: 250 } }}
                size="small"
                label={bt("STATUS")}
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <MenuItem value={"all"}>
                  <Typography>{bt("ALL_STATUS")}</Typography>
                </MenuItem>
                {ST_TYPE?.map((st, index) => {
                  return (
                    <MenuItem key={index} value={st?.id}>
                      <Typography>{bt(st.name)}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </NullCheck>

          {/* select pmt status */}
          <NullCheck valueForCheck={showPmtSt}>
            <FormControl fullWidth>
              <InputLabel >{bt("PMT_TYPE")}</InputLabel>
              <Select
                sx={{ width: { xs: "100%", md: 250 } }}
                size="small"
                label={bt("PMT_TYPE")}
                value={selectedPmtType}
                onChange={(e) => setSelectedPmtType(e.target.value)}
              >
                <MenuItem value={"all"}>
                  <Typography>{bt("ALL_PMT")}</Typography>
                </MenuItem>
                {PMT_TYPE?.map((pmt, index) => {
                  return (
                    <MenuItem key={index} value={pmt?.id}>
                      <Typography>{bt(pmt.name)}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </NullCheck>
        </Stack>

        <Stack width="100%" direction={{ xs: "column", md: "row" }} spacing={1}>
          {/* invoice status */}
          <NullCheck valueForCheck={showInvoiceSt}>
            <FormControl fullWidth>
              <InputLabel >{bt("INVOICE_STATUS")}</InputLabel>
              <Select
                sx={{ width: { xs: "100%", md: 250 } }}
                size="small"
                label={bt("INVOICE_STATUS")}
                value={selectedInvoiceStatus}
                onChange={(e) => setSelectedInvoiceStatus(e.target.value)}
              >
                <MenuItem value={"all"}>
                  <Typography>{bt("ALL")}</Typography>
                </MenuItem>
                <MenuItem value={"full"}>
                  <Typography>{bt("FULL")}</Typography>
                </MenuItem>
                <MenuItem value={"empty"}>
                  <Typography>{bt("EMPTY")}</Typography>
                </MenuItem>
              </Select>
            </FormControl>
          </NullCheck>

          {/* mc */}
          <NullCheck valueForCheck={mcList?.length > 0}>
            <FormControl fullWidth>
              <InputLabel >{bt("MICRO_CONTROLLERS")}</InputLabel>
              <Select
                sx={{ width: { xs: "100%", md: 250 } }}
                size="small"
                label={bt("MICRO_CONTROLLERS")}
                value={selectedMc}
                onChange={(e) => setSelectedMc(e.target.value)}
              >
                {mcList?.map((mc, index) => {
                  return (
                    <MenuItem key={index} value={mc?.guid}>
                      <Typography>{mc?.name}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </NullCheck>
        </Stack>
      </Stack>

    </CustomDialog>
  );
};
export default CustomSearch;
